export default "__VITE_ASSET__BAvR6HuO__"